import { useQueryParam } from '@hooks/use-query';
import { useAppSelector } from '@store';

export const useFinishStepState = () => {
    const organizationId = useAppSelector((state) => state.dashboard?.session?.organizationId);
    const sdkOptions = useAppSelector((state) => state.docsVerification.sdkOptions);
    const isWeb3 = useAppSelector((state) => state.docsVerification.sdkOptions?.isWeb3);
    const apiUrl = useAppSelector((state) => state.docsVerification.sdkOptions?.apiUrl);
    const verificationId = useAppSelector((state) => state.docsVerification.verificationId);
    const shortId = useAppSelector((state) => state.docsVerification.sdkOptions?.id) as string;
    const isCustomPartner = useAppSelector(
        (state) => state.docsVerification.sdkOptions?.customPartner?.concordium,
    );
    const queryParam = useQueryParam();
    const botName = queryParam.search.get('botName');

    return {
        organizationId,
        sdkOptions,
        isWeb3,
        apiUrl,
        verificationId,
        shortId,
        isCustomPartner,
        isInDashboard: !organizationId,
        isTelegram: sdkOptions?.source === 'telegram',
        botName,
    };
};

export type FinishStepState = ReturnType<typeof useFinishStepState>;
